import React from "react"
import { concatStrings } from "../utilities"
import CTooltipIcon from "../elements/c_tooltip_icon"
import content from "../../content"
import { withPrefix } from "gatsby"

const DfbAnchor = (props) => {
  const TagName = `${props.tagName.toLowerCase()}`
  let linkOverride = props.link
  let targetOverride = null

  if (typeof props.link === "object") {
    linkOverride = props.link.url
    targetOverride = props.link.target
  }

  const anchorLink = TagName === "a" ? { href: withPrefix(linkOverride) } : {}
  let external = TagName === "a" && props.external ? { target: "_blank" } : {}
  external =
    TagName === "a" && targetOverride ? { target: targetOverride } : external
  const buttonType = TagName === "button" ? { type: props.type } : {}
  const disabled =
    props.disabled && ["a", "button"].indexOf(TagName) !== -1
      ? { disabled: true }
      : {}
  const secondaryClass = props.secondary ? "dfb-Anchor--secondary" : ""
  const testid = props.testid ? props.testid : null
  return (
    <TagName
      {...anchorLink}
      {...buttonType}
      {...disabled}
      {...external}
      className={concatStrings("dfb-Anchor", secondaryClass, props.add_class)}
      data-testid={testid}
    >
      <span className="dfb-Anchor-label">{props.text}</span>
      {props.locked && (
        <CTooltipIcon
          tooltip={content.global.restrictedTooltip}
          icon="locked"
          small={true}
        />
      )}
    </TagName>
  )
}

DfbAnchor.defaultProps = {
  tagName: "a",
  type: "",
  secondary: false,
  disabled: false,
  external: false,
}

export default DfbAnchor
